module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-4-b3001294f334c08728de496faa2522c2.jpg";